export default __webpack_public_path__ + "static/media/leg-left-inside.5bf3fcb0.png";